import ZoetisC from "../../../../src/components/RenderImgs/zoetisImgs_carousel";
import Zoetis from "../../../../src/components/RenderImgs/zoetisImgs";
import * as React from 'react';
export default {
  ZoetisC,
  Zoetis,
  React
};